import React, { useState, useEffect, useMemo } from "react";
import { Card } from "reactstrap";
import Previous from "../../../../assets/image/icons/Previous.png";
import Payment from "../../../../assets/image/dashboard/payment.svg";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import Copy from "../../../../assets/image/icons/copy.svg";
import { formatDateWithTime } from "../../../../utils/dateUtils";
import { useUserTimezoneFormatter } from "../../../../components/UserTimezoneDateFormatter/UserTimezoneDateFormatter";
import {
  Box,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Tooltip,
  useTheme,
} from "@mui/material";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { DisplayImage } from "../../../../components/Files/DisplayFiles";
import InvoiceMail from "../InvoiceMail";
import Signature from "../../../../assets/image/icons/Signature.svg";
import DeleteSweepOutlinedIcon from "@mui/icons-material/DeleteSweepOutlined";
import {
  EditIcon,
  LoaderComponent,
  OrangeButton,
  ProductItem,
} from "../../../../components/Icon/Index";
import "./style.css";
import "../../Quotes/Views/style.css";
import { handleAuth } from "../../../../components/Login/Auth";
import { useAdminDarkMode } from "../../../../contexts/AdminDarkModeContext";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import StickyNote2OutlinedIcon from "@mui/icons-material/StickyNote2Outlined";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import { Grid } from "@mui/material";
import { Col } from "react-bootstrap";
import { useStaffContext } from "../../../../components/StaffData/Staffdata";

import BlueButton, {
  GreyButton,
} from "../../../../components/Button/BlueButton";
import WhiteButton from "../../../../components/Button/WhiteButton";
import AllDropdown from "../../../../components/Dropdown/Dropdown";
import FooterDetails from "../../../../components/UserFooter/UserFooter";
import { Typography } from "@mui/material";

const getJobberStatusChipStyle = (status) => {
  const normalized = String(status || "").trim().toLowerCase();

  if (normalized.includes("converted")) {
    return { backgroundColor: "#EDE9FE", color: "#5B21B6" };
  }
  if (normalized.includes("change request") || normalized.includes("request changed")) {
    return { backgroundColor: "#FCE7F3", color: "#9D174D" };
  }
  if (normalized.includes("unscheduled")) {
    return { backgroundColor: "#FEF9C3", color: "#92400E" };
  }
  if (normalized.includes("scheduled")) {
    return { backgroundColor: "#DBEAFE", color: "#1E40AF" };
  }
  if (["unpaid", "overdue", "cancel", "declined", "rejected", "failed", "void"].some((key) => normalized.includes(key))) {
    return { backgroundColor: "#FEE2E2", color: "#991B1B" };
  }
  if (["active", "approved", "paid"].some((key) => normalized.includes(key))) {
    return { backgroundColor: "#D1FAE5", color: "#065F46" };
  }
  if (["draft", "inactive"].some((key) => normalized.includes(key))) {
    return { backgroundColor: "#F3F4F6", color: "#4B5563" };
  }
  return { backgroundColor: "#F3F4F6", color: "#4B5563" };
};

const InvoiceDetail = ({
  loader,
  CompanyUrl,
  location,
  invoicedata,
  setMail,
  handleEditClick,
  dropdownOpen,
  toggle,
  handleCopy,
  open,
  setOpen,
  file,
  mail,
  data,
  options,
  navigate,
  handleCancelInvoice,
  invoiceStatus,
  baseUrl,
  setFile,
  menuItems,
  progress,
  collectSignatureLoader,
  openSignPDF,
  handleOpenSignPDFDialog,
  handleCloseDialog,
  selectedFileUri,
  handleDropboxDelete,
  dateFormat,
  tokenDecode,
  isDonationMode,
}) => {
  const theme = useTheme();
  const { darkMode: adminDark } = useAdminDarkMode();
  const detailDark = adminDark || theme.palette.mode === "dark";
  const d = useMemo(
    () => ({
      cardShell: {
        borderRadius: "10px",
        boxShadow: detailDark
          ? "0 1px 3px rgba(0, 0, 0, 0.35)"
          : "0 1px 3px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.06)",
        border: detailDark ? "1px solid #2d3b4e" : "1px solid #e8eaef",
        backgroundColor: detailDark ? "#1a2332" : "#fff",
      },
      head: detailDark ? "#e8eaed" : "var(--navy-deep, #0f2b46)",
      ink: detailDark ? "#e8eaed" : "#0f172a",
      inkStrong: detailDark ? "#f1f5f9" : "#0c1222",
      muted: detailDark ? "#9aa0a6" : "#64748b",
      body: detailDark ? "#c4cad1" : "#334155",
      dd: detailDark ? "#e8eaed" : "#0f172a",
      borderHairline: detailDark ? "#2d3b4e" : "#eef2f6",
      disclaimerBg: detailDark ? "#3a2a0f" : "#F9F4F2",
      disclaimerInk: detailDark ? "#fde68a" : "#B89100",
      disclaimerBorder: detailDark ? "rgba(251, 191, 36, 0.35)" : "transparent",
      noteStrong: detailDark ? "#e8eaed" : "#0f172a",
      noteBody: detailDark ? "#c4cad1" : "#334155",
      roleBg: detailDark ? "rgba(96, 165, 250, 0.12)" : "rgba(15, 43, 70, 0.08)",
      roleInk: detailDark ? "#b8c5d6" : "var(--navy-deep, #0f2b46)",
      roleBorder: detailDark ? "rgba(96, 165, 250, 0.28)" : "rgba(15, 43, 70, 0.15)",
      totalRule: detailDark ? "#4b5563" : "#334155",
      noteEmpty: detailDark ? "#9aa0a6" : "#94a3b8",
    }),
    [detailDark]
  );
  const quoteDetailCardShell = d.cardShell;

  // Use timezone-aware date formatter hook
  const formatDateWithUserTimezone = useUserTimezoneFormatter();

  const [copyTooltipOpen, setCopyTooltipOpen] = useState(false);

  /**
   * JOB-3162: the backend's `subTotal` field is sometimes $0.00 while
   * `Total` is correctly computed — produces the jarring "Subtotal $0.00
   * but Total $600" display on invoices #501 / #503. Recover by computing
   * the subtotal from the line items, with a final fallback to Total so
   * we never show $0 against a non-zero total.
   */
  const resolvedSubTotal = (() => {
    const st = Number(invoicedata?.subTotal);
    if (st && !Number.isNaN(st)) return st;
    const items = Array.isArray(invoicedata?.Items) ? invoicedata.Items : [];
    const fromItems = items.reduce((sum, line) => {
      const lineTotal = Number(line?.Total);
      if (!Number.isNaN(lineTotal) && lineTotal) return sum + lineTotal;
      const qty = Number(line?.Quantity) || 0;
      const price = Number(line?.UnitCost ?? line?.Price ?? 0);
      return sum + qty * price;
    }, 0);
    if (fromItems) return fromItems;
    const total = Number(invoicedata?.Total);
    return Number.isNaN(total) ? 0 : total;
  })();

  const openFileModal = (attachment) => {
    setFile(attachment);
    setOpen(true);
  };

  const { staffData } = useStaffContext();

  const [timeFormat, setTimeFormat] = useState("12h");
  useEffect(() => {
    const fetchTimeFormat = async () => {
      try {
        const res = await handleAuth(navigate, location);
        setTimeFormat(res?.data?.TimeFormat || "12h");
      } catch {
        setTimeFormat("12h");
      }
    };
    fetchTimeFormat();
  }, [navigate, location]);

  // Helper function to format address
  const formatAddress = (location) => {
    if (!location) return "Address not available";
    
    const address = location.Address || "";
    const city = location.City || "";
    const state = location.State || "";
    const zip = location.Zip || location.ZipCode || "";
    
    // Check if all address fields are empty
    if (!address && !city && !state && !zip) {
      return "Address not available";
    }
    
    // Build address string with only available fields
    const addressParts = [];
    if (address) addressParts.push(address);
    if (city) addressParts.push(city);
    if (state) addressParts.push(state);
    if (zip) addressParts.push(zip);
    
    return addressParts.join(", ");
  };

  const handleCopyWithTooltip = async () => {
    try {
      const firstName = invoicedata?.customer?.FirstName || "";
      const lastName = invoicedata?.customer?.LastName || "";
      const fullName = `${firstName} ${lastName}`.trim();
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(fullName);
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = fullName;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand("copy");
        textArea.remove();
      }

      setCopyTooltipOpen(true);
      setTimeout(() => {
        setCopyTooltipOpen(false);
      }, 2000);

      if (handleCopy) {
        handleCopy();
      }
    } catch (error) {
      console.error("Error copying text:", error);
      setCopyTooltipOpen(true);
      setTimeout(() => {
        setCopyTooltipOpen(false);
      }, 2000);
    }
  };

  const fmtMoney = (n) =>
    `$${new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(n) || 0)}`;

  const clientFullName =
    `${invoicedata?.customer?.FirstName || ""} ${invoicedata?.customer?.LastName || ""}`.trim() ||
    "Client name not available";

  const pageMainTitle =
    (invoicedata?.Subject && String(invoicedata.Subject).trim()) ||
    (invoicedata?.account_name && String(invoicedata.account_name).trim()) ||
    clientFullName;

  const invoiceCreatedAt =
    invoicedata?.createdAt || invoicedata?.CreatedAt || invoicedata?.updatedAt || "";

  const internalNoteBlocks = String(invoicedata?.Notes || "")
    .split(/\n{2,}/)
    .map((s) => s.trim())
    .filter(Boolean);

  const invoiceStatusChipColors = useMemo(() => {
    const base = getJobberStatusChipStyle(invoiceStatus);
    if (theme.palette.mode !== "dark") return base;
    // Dark-mode remap: base.color is a deep pastel ink (e.g. #065F46) which
    // renders invisible over a dark paper. Swap in a bright hue + tinted
    // translucent bg per status family so each badge stays readable.
    const darkVariants = {
      "#EDE9FE": { backgroundColor: "rgba(139, 92, 246, 0.18)", color: "#c4b5fd" },
      "#FCE7F3": { backgroundColor: "rgba(236, 72, 153, 0.18)", color: "#f9a8d4" },
      "#FEF9C3": { backgroundColor: "rgba(250, 204, 21, 0.18)", color: "#fde68a" },
      "#DBEAFE": { backgroundColor: "rgba(59, 130, 246, 0.20)", color: "#93c5fd" },
      "#FEE2E2": { backgroundColor: "rgba(239, 68, 68, 0.20)", color: "#fca5a5" },
      "#D1FAE5": { backgroundColor: "rgba(16, 185, 129, 0.20)", color: "#6ee7b7" },
      "#F3F4F6": { backgroundColor: "rgba(255, 255, 255, 0.08)", color: "#d1d5db" },
      "#F9F4F2": { backgroundColor: "rgba(255, 255, 255, 0.08)", color: "#d1d5db" },
    };
    return darkVariants[base.backgroundColor] || base;
  }, [invoiceStatus, theme.palette.mode]);
  const statusIsPositive = ["paid", "approved", "active"].some((k) =>
    String(invoiceStatus || "")
      .toLowerCase()
      .includes(k)
  );

  const invoiceAttachmentsRaw = invoicedata?.Attachment;
  const hasInvoiceAttachments =
    invoiceAttachmentsRaw != null &&
    invoiceAttachmentsRaw !== "" &&
    (Array.isArray(invoiceAttachmentsRaw)
      ? invoiceAttachmentsRaw.length > 0
      : true);

  const normalizeTaxTypeDisplay = (type) => {
    if (!type) return "";
    if (type === "Material" || type.toLowerCase() === "material") {
      return "Materials";
    }
    return type;
  };

  return (
    <>
      {collectSignatureLoader ? (
        <Grid
          className="d-flex flex-direction-row justify-content-center align-items-center"
          style={{ height: "80vh" }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            position="relative"
          >
            <CircularProgress
              variant="determinate"
              value={progress}
              size={90}
              thickness={2}
              sx={{
                color: "#D4943A",
              }}
            />
            <Typography
              className="text-blue-color"
              variant="caption"
              component="div"
              color="textSecondary"
              style={{
                position: "absolute",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              {`${progress}%`}
            </Typography>
          </Box>
        </Grid>
      ) : loader ? (
        <Grid className="Typography-5 m-2 m-md-3" sx={{ width: "100%", maxWidth: "100%" }}>
          <LoaderComponent
            variant="skeleton"
            skeletonLayout="detail"
            isDonationMode={isDonationMode}
            loader={loader}
            height="50"
            width="50"
          />
        </Grid>
      ) : (
        <Grid className="Quote-details quote-detail-cjm qdj-atlas qdj-quote-redesign">
          <Grid
            container
            spacing={2}
            className="qdj-quote-shell"
            sx={{
              width: "100%",
              maxWidth: "100%",
              boxSizing: "border-box",
              margin: 0,
              alignItems: "flex-start",
            }}
          >
            <Grid sx={{ pt: "0 !important", paddingTop: "0 !important" }} size={12}>
            <Grid className="d-flex justify-content-between buttonGroup nevigate_collect_cancel_invoice emailEditAction_btn">
              <Grid style={{ display: "flex" }}>
                <IconButton
                  type="button"
                  aria-label="Back"
                  onClick={() => {
                    const path =
                      tokenDecode?.Role === "Company"
                        ? `/${CompanyUrl}/invoice`
                        : `/${CompanyUrl}/staff-member/worker-invoice`;

                    navigate(path, {
                      state: {
                        navigats: location?.state?.navigats?.filter(
                          (item) => item !== "/contract"
                        ),
                      },
                    });
                  }}
                  sx={{
                    mr: "10px",
                    width: 50,
                    height: 40,
                    borderRadius: "4px",
                    bgcolor: detailDark ? "#3d4f66" : "#EEEEEF",
                    color: detailDark ? "#fff" : "#063164",
                    "&:hover": {
                      bgcolor: detailDark ? "#4d5f7a" : "#e2e2e4",
                    },
                  }}
                >
                  <ArrowBackIcon sx={{ fontSize: 22 }} />
                </IconButton>
              </Grid>
              <Grid className="d-flex justify-content-end gap-2 buttonGroupthree  cancelInvoice_collectPayment_mail_btn emailEditAction_btn">
                {CompanyUrl && (
                  <OrangeButton
                    isDonationMode={isDonationMode}
                    className="cancelInvoice_btn"
                    onClick={handleCancelInvoice}
                    disabled={
                      invoiceStatus === "Canceled" || invoiceStatus === "Paid"
                    }
                    label={
                      <Grid
                        style={{
                          fontSize: "14px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img src={Payment} alt="Payment Icon" />
                        &nbsp;
                        {invoiceStatus === "Canceled"
                          ? "Invoice Cancelled"
                          : "Cancel Invoice "}
                      </Grid>
                    }
                  />
                )}

                {tokenDecode.Role === "Company" && (
                  <OrangeButton
                    isDonationMode={isDonationMode}
                    onClick={() =>
                      navigate(`/${CompanyUrl}/invoice-payment`, {
                        state: {
                          navigats: [
                            ...location?.state?.navigats,
                            "/invoice-payment",
                          ],
                          id: invoicedata?.InvoiceId,
                        },
                      })
                    }
                    disabled={
                      invoiceStatus === "Canceled"
                    }
                    label={
                      <Grid
                        style={{
                          fontSize: "14px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={Payment}
                          alt=""
                          style={{ width: "20px", height: "20px" }}
                        />
                        &nbsp;
                        {invoiceStatus === "Paid"
                          ? "View Payment Details"
                          : "Collect Payment"}
                      </Grid>
                    }
                  />
                )}
                <OrangeButton
                  isDonationMode={isDonationMode}
                  className=""
                  style={{ fontSize: "14px" }}
                  onClick={() => {
                    setMail(true);
                  }}
                  label={
                    <>
                      <MailOutlineOutlinedIcon style={{ marginRight: "8px" }} />
                      Send Email
                    </>
                  }
                />
                <Grid className="editButton">
                  <WhiteButton
                    isDonationMode={isDonationMode}
                    className="invoiceEditBtn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditClick();
                    }}
                    disabled={
                      invoiceStatus === "Canceled" ||
                      invoiceStatus === "Paid" ||
                      staffData?.Invoice?.ViewOnly
                    }
                    label={
                      <>
                        <EditIcon className="editImagePayment" />
                        <span
                          className={
                            invoiceStatus === "Canceled" ||
                            invoiceStatus === "Paid" ||
                            staffData?.Invoice?.ViewOnly
                              ? "disabledText"
                              : ""
                          }
                        >
                          Edit
                        </span>
                      </>
                    }
                  />
                </Grid>

                <AllDropdown
                  isDonationMode={isDonationMode}
                  isOpen={dropdownOpen}
                  toggle={toggle}
                  menuItems={menuItems}
                  style={{ zIndex: 1 }}
                />
              </Grid>
            </Grid>
            </Grid>
            <Grid size={12}>
            <Box
              className="qdj-quote-page-masthead justify-content-between d-flex align-items-center"
              sx={{
                flexWrap: "wrap",
                gap: 2,
                mb: 2,
                width: "100%",
              }}
            >
              <Box sx={{ flex: "1 1 260px", minWidth: 0 }}>
                <Typography
                  className="qdj-quote-page-title text-blue-color heading-three"
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: "1.25rem", sm: "1.5rem" },
                    color: "text.primary",
                    letterSpacing: "-0.02em",
                    lineHeight: 1.25,
                    wordBreak: "break-word",
                    mb: 0,
                    mt: 0,
                  }}
                >
                  {pageMainTitle}
                  <Tooltip
                    title="Copied!"
                    open={copyTooltipOpen}
                    placement="top"
                    arrow
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "var(--amber)",
                          color: "white",
                          fontSize: "14px",
                          padding: "8px 12px",
                          borderRadius: "4px",
                          boxShadow: "var(--shadow-md)",
                          fontWeight: "500",
                        },
                      },
                      arrow: { sx: { color: "var(--amber)" } },
                    }}
                  >
                    <IconButton
                      type="button"
                      onClick={handleCopyWithTooltip}
                      aria-label="Copy"
                      size="small"
                      sx={{
                        ml: "10px",
                        verticalAlign: "middle",
                        width: 36,
                        height: 36,
                        borderRadius: "8px",
                        bgcolor: detailDark ? "#3d4f66" : "#EEEEEF",
                        color: detailDark ? "#fff" : "#063164",
                        "&:hover": {
                          bgcolor: detailDark ? "#4d5f7a" : "#e2e2e4",
                        },
                      }}
                    >
                      <ContentCopyOutlinedIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                </Typography>
                <Typography
                  component="div"
                  className="qdj-quote-number-under-title text-blue-color"
                  sx={{
                    mt: 0.5,
                    fontSize: { xs: "1rem", sm: "1.125rem" },
                    fontWeight: 600,
                    color: "text.primary",
                    letterSpacing: "0.02em",
                    lineHeight: 1.45,
                  }}
                >
                  Invoice #
                  {invoicedata?.InvoiceNumber ?? "—"}
                </Typography>
              </Box>
              <Box
                className="qdj-quote-masthead-badges d-flex align-items-center flex-wrap"
                sx={{
                  gap: 1,
                  justifyContent: { xs: "flex-start", sm: "flex-end" },
                  flex: "0 1 auto",
                }}
              >
                <Box
                  component="span"
                  className="quote-detail-status-chip"
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "6px 12px",
                    borderRadius: "9999px",
                    fontSize: "12px",
                    fontWeight: 600,
                    lineHeight: 1.2,
                    backgroundColor: invoiceStatusChipColors.backgroundColor,
                    color: invoiceStatusChipColors.color,
                    whiteSpace: "nowrap",
                    border: `1px solid ${invoiceStatusChipColors.color}33`,
                  }}
                >
                  {statusIsPositive ? (
                    <CheckCircleOutlinedIcon sx={{ fontSize: 16 }} />
                  ) : (
                    <Box
                      component="span"
                      aria-hidden
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        flexShrink: 0,
                        backgroundColor: invoiceStatusChipColors.color,
                        opacity: 0.85,
                      }}
                    />
                  )}
                  {invoiceStatus || "Status not available"}
                </Box>
                <Typography
                  component="span"
                  className="contractDetailType qdj-quote-role-chip"
                  sx={{
                    fontSize: "13px",
                    display: "inline-flex",
                    backgroundColor: d.roleBg,
                    color: d.roleInk,
                    padding: "6px 12px",
                    borderRadius: "20px",
                    fontWeight: 600,
                    alignItems: "center",
                    border: `1px solid ${d.roleBorder}`,
                    whiteSpace: "nowrap",
                  }}
                >
                  {invoicedata?.CreatedByRole || "Role not available"}
                </Typography>
              </Box>
            </Box>
            </Grid>
            {/* Two-col row: main 8/12, side 4/12 on md+ — mirror ContractDetails/QuoteDetails
                so the summary/notes rail stays beside the main column at all
                supported widths instead of wrapping below it (JOB-3214). */}
            <Grid
              container
              spacing={2}
              className="qdj-contract-detail-two-col-row"
              sx={{
                width: "100%",
                maxWidth: "100%",
                mt: 0,
                mb: 0,
                paddingTop: 0,
                flexWrap: { xs: "wrap", md: "nowrap" },
                alignItems: "flex-start",
                boxSizing: "border-box",
              }}
              size={12}
            >
            <Grid
              className="qdj-quote-col-main qdj-quote-two-col"
              sx={{
                flexBasis: { xs: "100%", md: "66.666667%", lg: "66.666667%" },
                maxWidth: { xs: "100%", md: "66.666667%", lg: "66.666667%" },
                flexGrow: 0,
                flexShrink: { xs: 1, md: 0 },
                minWidth: 0,
              }}
              size={{
                xs: 12,
                md: 8,
                lg: 8
              }}>
              <Card
                className="p-3 my-3 qdj-qd-card qdj-client-property-card"
                style={quoteDetailCardShell}
              >
                <CardContent className="pt-2 px-2 pb-2">
                  <Grid
                    container
                    spacing={2}
                    className="address_quoteDetail addressQuoteDesktop"
                  >
                    <Grid
                      className="property_address"
                      size={{
                        xs: 12,
                        md: 6
                      }}>
                      <Box
                        className="qdj-qd-section-head"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 1.5,
                          color: d.head,
                          fontWeight: 700,
                          fontSize: 15,
                        }}
                      >
                        <PersonOutlineOutlinedIcon sx={{ fontSize: 22 }} />
                        Client Information
                      </Box>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: "1.05rem",
                          color: d.inkStrong,
                          mb: 0.5,
                        }}
                      >
                        {clientFullName}
                      </Typography>
                      <Typography sx={{ fontSize: 14, color: d.muted }}>
                        {invoicedata?.customer?.EmailAddress || "—"}
                      </Typography>
                      <Typography sx={{ fontSize: 14, color: d.muted }}>
                        {invoicedata?.customer?.PhoneNumber || "—"}
                      </Typography>
                    </Grid>
                    <Grid
                      className="quoteDetailsRightCol"
                      size={{
                        xs: 12,
                        md: 6
                      }}>
                      <Box
                        className="qdj-qd-section-head"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 1.5,
                          color: d.head,
                          fontWeight: 700,
                          fontSize: 15,
                        }}
                      >
                        <LocationOnOutlinedIcon sx={{ fontSize: 22 }} />
                        Property Address
                      </Box>
                      <Typography
                        sx={{
                          fontSize: 14,
                          color: d.body,
                          lineHeight: 1.55,
                          wordBreak: "break-word",
                        }}
                      >
                        {formatAddress(invoicedata?.location)}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: 600,
                          color: d.muted,
                          mt: 1.5,
                          mb: 0.5,
                        }}
                      >
                        Service Address
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 14,
                          color: d.body,
                          lineHeight: 1.55,
                          wordBreak: "break-word",
                        }}
                      >
                        {formatAddress(invoicedata?.location)}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.75,
                          mt: 1.5,
                          color: d.muted,
                          fontSize: 13,
                        }}
                      >
                        <ScheduleOutlinedIcon sx={{ fontSize: 18 }} />
                        <span>
                          Created:{" "}
                          {invoiceCreatedAt
                            ? formatDateWithUserTimezone(invoiceCreatedAt, {
                                dateFormat,
                                includeSeconds: true,
                                timeFormat,
                              })
                            : "—"}
                        </span>
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              <Card
                className="p-3 my-3 qdj-qd-card qdj-contract-details-card"
                style={quoteDetailCardShell}
              >
                <CardContent className="pt-2 px-2 pb-2">
                  <Box
                    className="qdj-qd-section-head"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 2,
                      color: d.head,
                      fontWeight: 700,
                      fontSize: 15,
                    }}
                  >
                    <DescriptionOutlinedIcon sx={{ fontSize: 22 }} />
                    Invoice Details
                  </Box>
                  <Box
                    component="dl"
                    sx={{
                      m: 0,
                      "& > div": { py: 1.25, borderBottom: `1px solid ${d.borderHairline}` },
                      "& > div:last-of-type": { borderBottom: "none", pb: 0 },
                    }}
                  >
                    <Box
                      component="div"
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: 2,
                      }}
                    >
                      <Typography
                        component="dt"
                        sx={{
                          fontSize: 14,
                          color: d.muted,
                          fontWeight: 500,
                          flex: "0 1 42%",
                          m: 0,
                        }}
                      >
                        Issued
                      </Typography>
                      <Typography
                        component="dd"
                        sx={{
                          fontSize: 14,
                          fontWeight: 600,
                          color: d.dd,
                          textAlign: "right",
                          m: 0,
                          flex: "1 1 58%",
                        }}
                      >
                        {(() => {
                          // JOB-3164 + JOB-3178: IssueDate is only populated
                          // on invoices explicitly "issued" — older data and
                          // drafts-converted-to-sent leave it null. Fall back
                          // to SentAt (when the invoice was sent) and finally
                          // createdAt so the Issued field never shows "—"
                          // on an invoice that indisputably has a date.
                          const issued =
                            invoicedata?.IssueDate ||
                            invoicedata?.SentAt ||
                            invoicedata?.createdAt;
                          return issued
                            ? formatDateWithUserTimezone(issued, {
                                dateFormat,
                                includeSeconds: false,
                              })
                            : "—";
                        })()}
                      </Typography>
                    </Box>
                    <Box
                      component="div"
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: 2,
                      }}
                    >
                      <Typography
                        component="dt"
                        sx={{
                          fontSize: 14,
                          color: d.muted,
                          fontWeight: 500,
                          flex: "0 1 42%",
                          m: 0,
                        }}
                      >
                        Due
                      </Typography>
                      <Typography
                        component="dd"
                        sx={{
                          fontSize: 14,
                          fontWeight: 600,
                          color: d.dd,
                          textAlign: "right",
                          m: 0,
                          flex: "1 1 58%",
                        }}
                      >
                        {invoicedata?.DueDate
                          ? formatDateWithUserTimezone(invoicedata.DueDate, {
                              dateFormat,
                              includeSeconds: false,
                            })
                          : "—"}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>

              <Card className="p-3 my-3 qdj-qd-card" style={quoteDetailCardShell}>
                <CardContent className="pt-1 px-2 pb-2">
                  <Box
                    className="qdj-qd-section-head"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 2,
                      color: d.head,
                      fontWeight: 700,
                      fontSize: 15,
                    }}
                  >
                    <DescriptionOutlinedIcon sx={{ fontSize: 22 }} />
                    Materials & Labor
                  </Box>
                  <Grid className="qdj-line-items">
                    {invoicedata?.Items?.length > 0 ? (
                      invoicedata?.Items?.map((item, index) => (
                        <ProductItem
                          key={index}
                          item={item}
                          index={index}
                          baseUrl={baseUrl}
                          openFileModal={openFileModal}
                          open={open}
                          setOpen={setOpen}
                          file={file}
                          quoteDetailV2
                          quoteDetailAtlas
                        />
                      ))
                    ) : (
                      <Grid className="text-center text-blue-color" sx={{ py: 2 }}>
                        <Typography
                          className="mb-1"
                          style={{ fontSize: "15px", fontWeight: 600 }}
                        >
                          {/* JOB-3163: the prior "Product/Service not available"
                              placeholder was jarring on invoices with a real
                              Total but no expanded line items. Replace with
                              a clean empty-state + Total echo so the cost is
                              still surfaced.
                              JOB-3178: hide the echo when Total is zero or
                              missing, and use the dark-aware muted token. */}
                          No line items recorded on this invoice
                        </Typography>
                        {Number(invoicedata?.Total || 0) > 0 && (
                          <Typography
                            className="mb-0 mt-2"
                            style={{
                              fontSize: "14px",
                              fontWeight: 400,
                              color: d.muted,
                            }}
                          >
                            Invoice total: {fmtMoney(Number(invoicedata?.Total || 0))}
                          </Typography>
                        )}
                      </Grid>
                    )}
                  </Grid>
                </CardContent>
              </Card>

              {invoicedata?.dropboxFiles?.length > 0 ? (
                <Card className="p-3 my-3 qdj-qd-card" style={quoteDetailCardShell}>
                  <CardContent className="pt-2 px-2 pb-2">
                    <Box
                      className="qdj-qd-section-head"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 2,
                        color: d.head,
                        fontWeight: 700,
                        fontSize: 15,
                      }}
                    >
                      <DrawOutlinedIcon sx={{ fontSize: 22 }} />
                      E-Signature Documents
                    </Box>
                    <Grid className="mb-3 p-1">
                      {invoicedata.dropboxFiles.map((sigFile, index) => {
                        let signatureStatus = "unknown";
                        if (sigFile?.isComplete === true && sigFile?.signedAt) {
                          signatureStatus = "signed";
                        } else if (sigFile?.isDeclined === true) {
                          signatureStatus = "declined";
                        } else if (sigFile?.sentAt || sigFile?.createdAt) {
                          signatureStatus = "awaiting_signature";
                        }

                        return (
                          <Grid
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              flexWrap: "wrap",
                              gap: "10px",
                              marginBottom: "15px",
                            }}
                          >
                            <Typography
                              onClick={() => {
                                if (sigFile?.signatureRequestId) {
                                  const apiBase =
                                    import.meta.env.VITE_BASE_API || "";
                                  const pdfUrl = `${apiBase}/v1/signature/signature_request/files_as_data_uri/${sigFile.signatureRequestId}`;
                                  handleOpenSignPDFDialog(pdfUrl);
                                }
                              }}
                              style={{
                                cursor: sigFile?.signatureRequestId
                                  ? "pointer"
                                  : "default",
                                alignItems: "center",
                                display: "flex",
                                paddingLeft: "5px",
                                flex: "1 1 auto",
                                minWidth: "200px",
                                flexWrap: "wrap",
                              }}
                            >
                              <img src={Signature} alt="Signature" />
                              <span
                                style={{
                                  fontWeight: 700,
                                  fontSize: "14px",
                                  marginLeft: "12px",
                                }}
                                className="text-blue-color"
                              >
                                {index + 1} :{" "}
                                {signatureStatus === "awaiting_signature" ? (
                                  <span className="text-blue-color">
                                    Document Sent -{" "}
                                    {formatDateWithTime(
                                      sigFile?.sentAt || sigFile?.createdAt,
                                      dateFormat,
                                      timeFormat,
                                      true
                                    )}{" "}
                                  </span>
                                ) : signatureStatus === "signed" ? (
                                  <span
                                    style={{
                                      color: "var(--green)",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    Document Signed :{" "}
                                    {formatDateWithUserTimezone(
                                      sigFile?.signedAt || sigFile?.updatedAt,
                                      {
                                        dateFormat,
                                        timeFormat,
                                        includeSeconds: true,
                                      }
                                    )}
                                  </span>
                                ) : signatureStatus === "declined" ? (
                                  <span
                                    style={{
                                      color: "rgb(244, 67, 54)",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    Document Declined :{" "}
                                    {formatDateWithUserTimezone(
                                      sigFile?.declinedAt || sigFile?.updatedAt,
                                      {
                                        dateFormat,
                                        timeFormat,
                                        includeSeconds: true,
                                      }
                                    )}
                                  </span>
                                ) : (
                                  <span className="text-blue-color">
                                    Document Sent -{" "}
                                    {formatDateWithTime(
                                      sigFile?.sentAt || sigFile?.createdAt,
                                      dateFormat,
                                      timeFormat,
                                      true
                                    )}{" "}
                                  </span>
                                )}
                              </span>
                            </Typography>
                            {signatureStatus !== "signed" &&
                              signatureStatus !== "declined" && (
                                <Tooltip
                                  title="Delete your signature request"
                                  placement="top"
                                  arrow
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        backgroundColor: "var(--amber)",
                                        color: "white",
                                        fontSize: "14px",
                                        padding: "8px 12px",
                                        borderRadius: "4px",
                                        boxShadow: "var(--shadow-md)",
                                        fontWeight: "500",
                                      },
                                    },
                                    arrow: {
                                      sx: {
                                        color: "var(--amber)",
                                      },
                                    },
                                  }}
                                >
                                  <BlueButton
                                    onClick={() => {
                                      handleDropboxDelete(
                                        sigFile.signatureRequestId
                                      );
                                    }}
                                    style={{
                                      marginLeft: "auto",
                                      backgroundColor: "red",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "4px",
                                      padding: "6px 12px",
                                      cursor: "pointer",
                                    }}
                                    label={
                                      <DeleteSweepOutlinedIcon
                                        style={{ fontSize: "25px" }}
                                      />
                                    }
                                  />
                                </Tooltip>
                              )}
                          </Grid>
                        );
                      })}
                    </Grid>
                  </CardContent>
                </Card>
              ) : null}

              <Card className="p-3 my-3 qdj-qd-card" style={quoteDetailCardShell}>
                <CardContent className="pt-3">
                  <Box
                    className="qdj-qd-section-head"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 1.5,
                      color: d.head,
                      fontWeight: 700,
                      fontSize: 15,
                    }}
                  >
                    <ScheduleOutlinedIcon sx={{ fontSize: 22 }} />
                    Activity Timeline
                  </Box>
                  <FooterDetails
                    invoicedata={invoicedata}
                    options={options}
                    isDonationMode={isDonationMode}
                  />
                </CardContent>
              </Card>
            </Grid>

            <Grid
              className="qdj-quote-col-side"
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 0,
                flexBasis: { xs: "100%", md: "33.333333%", lg: "33.333333%" },
                maxWidth: { xs: "100%", md: "33.333333%", lg: "33.333333%" },
                minWidth: 0,
              }}
              size={{
                xs: 12,
                md: 4,
                lg: 4
              }}>
              <Card className="p-3 my-3 qdj-qd-card" style={quoteDetailCardShell}>
                <CardContent className="pt-3">
                  <Box
                    className="qdj-qd-section-head"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 2,
                      color: "#15803d",
                      fontWeight: 700,
                      fontSize: 15,
                    }}
                  >
                    <PaidOutlinedIcon sx={{ fontSize: 22, color: "#15803d" }} />
                    Cost Summary
                  </Box>
                  <Grid className="products-colum gap-2 contract-first-tax">
                    <Col
                      className="col-12 contract-first-tax-right"
                      xl={12}
                      md={12}
                      sm={12}
                    >
                      <Grid className="d-flex justify-content-between mb-3">
                        <Typography
                          className="text-blue-color fw-medium"
                          style={{ fontSize: "14px" }}
                        >
                          Subtotal
                        </Typography>
                        <Typography
                          className="text-blue-color"
                          style={{ fontSize: "14px" }}
                        >
                          {fmtMoney(resolvedSubTotal)}
                        </Typography>
                      </Grid>
                      {invoicedata?.CalculatedTaxes?.length > 0 &&
                        invoicedata.CalculatedTaxes.map((item, index) => {
                          const isPercentageTax =
                            item?.feeType === "Percentage" ||
                            (item?.percentage && item?.percentage > 0);
                          const taxAmount = item?.amount ?? 0;
                          let taxLabel;
                          if (isPercentageTax && item?.percentage > 0) {
                            taxLabel = `${item?.name} (${item?.percentage}%)${item?.type ? ` — ${normalizeTaxTypeDisplay(item?.type)}` : ""}`;
                          } else {
                            taxLabel = `${item?.name}${item?.type ? ` — ${normalizeTaxTypeDisplay(item?.type)}` : ""}`;
                          }
                          return (
                            <Grid key={item?.id || index} className="d-flex justify-content-between mb-2">
                              <Typography sx={{ fontSize: 14, color: d.muted, pr: 1 }}>
                                {taxLabel}
                              </Typography>
                              <Typography sx={{ fontSize: 14, fontWeight: 600, color: d.dd }}>
                                {fmtMoney(taxAmount)}
                              </Typography>
                            </Grid>
                          );
                        })}
                      {invoicedata?.Discount ? (
                        <Grid className="d-flex justify-content-between mb-3">
                          <Typography
                            className="text-blue-color fw-medium"
                            style={{ fontSize: "14px" }}
                          >
                            Discount
                          </Typography>
                          <Typography
                            style={{ fontSize: "14px" }}
                            className="text-blue-color"
                          >
                            {fmtMoney(
                              (resolvedSubTotal *
                                (invoicedata?.Discount || 0)) /
                                100
                            )}{" "}
                            ({invoicedata?.Discount}%)
                          </Typography>
                        </Grid>
                      ) : null}
                      {invoicedata?.Tax ? (
                        <Grid className="d-flex justify-content-between productTotalSub mb-3">
                          <Typography
                            className="text-blue-color fw-medium"
                            style={{ fontSize: "14px" }}
                          >
                            Tax
                          </Typography>
                          <Typography
                            style={{ fontSize: "14px" }}
                            className="text-blue-color"
                          >
                            {(() => {
                              const discount = Number(invoicedata?.Discount || 0);
                              const tax = Number(invoicedata?.Tax || 0);
                              const items = invoicedata?.Items || [];
                              const taxableSubTotal = items.reduce((sum, line) => {
                                const isNonTaxable =
                                  line?.IsNonTaxable === true ||
                                  line?.IsNonTaxable === "true" ||
                                  line?.IsNonTaxable === 1;
                                if (isNonTaxable) return sum;
                                return sum + Number(line?.Total || 0);
                              }, 0);
                              const discountedTaxableTotal =
                                taxableSubTotal - (discount / 100) * taxableSubTotal;
                              const taxAmount =
                                (discountedTaxableTotal * tax) / 100;
                              return `+${fmtMoney(taxAmount)} (${tax}%)`;
                            })()}
                          </Typography>
                        </Grid>
                      ) : null}
                      {(() => {
                        const hasCalculatedTaxes =
                          (invoicedata?.CalculatedTaxes || []).length > 0;
                        const hasLegacyTax = Number(invoicedata?.Tax || 0) > 0;
                        if (!hasCalculatedTaxes && !hasLegacyTax) return null;
                        const calculatedTaxTotal = (
                          invoicedata?.CalculatedTaxes || []
                        ).reduce((sum, t) => sum + parseFloat(t?.amount || 0), 0);
                        const items = invoicedata?.Items || [];
                        const taxableSubTotal = items.reduce((sum, line) => {
                          const isNonTaxable =
                            line?.IsNonTaxable === true ||
                            line?.IsNonTaxable === "true" ||
                            line?.IsNonTaxable === 1;
                          if (isNonTaxable) return sum;
                          return sum + parseFloat(line?.Total || 0);
                        }, 0);
                        const discount = parseFloat(invoicedata?.Discount || 0);
                        const discountedTaxableTotal =
                          taxableSubTotal - (discount / 100) * taxableSubTotal;
                        const legacyTaxAmount =
                          (parseFloat(invoicedata?.Tax || 0) / 100) *
                          discountedTaxableTotal;
                        const taxSubtotal =
                          calculatedTaxTotal + legacyTaxAmount;
                        return (
                          <Grid key="tax-subtotal" className="d-flex justify-content-between mb-3">
                            <Typography
                              className="text-blue-color fw-medium"
                              style={{ fontSize: "14px" }}
                            >
                              Tax Subtotal
                            </Typography>
                            <Typography
                              className="text-blue-color"
                              style={{ fontSize: "14px" }}
                            >
                              {fmtMoney(taxSubtotal)}
                            </Typography>
                          </Grid>
                        );
                      })()}
                      <Box
                        sx={{
                          borderTop: `3px solid ${d.totalRule}`,
                          my: 2,
                          pt: 2,
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography sx={{ fontWeight: 700, fontSize: 15, color: d.ink }}>
                          Total Amount
                        </Typography>
                        <Typography sx={{ fontWeight: 800, fontSize: 18, color: "#28a745" }}>
                          {fmtMoney(invoicedata?.Total || 0)}
                        </Typography>
                      </Box>
                    </Col>
                    <Col
                      className="col-12 contc"
                      xl={12}
                      style={{
                        backgroundColor: d.disclaimerBg,
                        padding: "15px",
                        borderRadius: "8px",
                        marginTop: "12px",
                        border: `1px solid ${d.disclaimerBorder}`,
                      }}
                    >
                      <Typography
                        className="mb-2"
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: `${d.disclaimerInk} !important`,
                        }}
                      >
                        {invoicedata?.Message || ""}
                      </Typography>
                      <Typography
                        className="text-data "
                        sx={{
                          fontSize: "14px",
                          width: "100%",
                          fontWeight: 400,
                          color: `${d.disclaimerInk} !important`,
                        }}
                      >
                        {invoicedata?.ContractDisclaimer || ""}
                      </Typography>
                    </Col>
                  </Grid>
                </CardContent>
              </Card>

              <Card className="p-3 my-3 qdj-qd-card" style={quoteDetailCardShell}>
                <CardContent className="pt-3">
                  <Box
                    className="qdj-qd-section-head"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 1.5,
                      color: "#c2410c",
                      fontWeight: 700,
                      fontSize: 15,
                    }}
                  >
                    <StickyNote2OutlinedIcon sx={{ fontSize: 22, color: "#c2410c" }} />
                    Internal Notes
                  </Box>
                  {internalNoteBlocks.length > 0 ? (
                    internalNoteBlocks.map((block, i) => (
                      <Box key={i} className="qdj-internal-note-box" sx={{ mb: 1.5 }}>
                        <Typography sx={{ fontSize: 12, color: d.muted, mb: 0.5 }}>
                          <strong style={{ color: d.noteStrong }}>Team</strong>
                          {" · "}
                          {invoiceCreatedAt
                            ? formatDateWithUserTimezone(invoiceCreatedAt, {
                                dateFormat,
                                includeSeconds: false,
                                timeFormat,
                              })
                            : "—"}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 13,
                            color: d.noteBody,
                            lineHeight: 1.55,
                            whiteSpace: "pre-line",
                          }}
                        >
                          {block}
                        </Typography>
                      </Box>
                    ))
                  ) : (
                    <Typography sx={{ fontSize: 14, color: d.noteEmpty }}>
                      No internal notes.
                    </Typography>
                  )}
                </CardContent>
              </Card>

              <Card className="p-3 my-3 qdj-qd-card" style={quoteDetailCardShell}>
                <CardContent className="pt-3">
                  <Box
                    className="qdj-qd-section-head"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 1.5,
                      color: "#6d28d9",
                      fontWeight: 700,
                      fontSize: 15,
                    }}
                  >
                    <AttachFileOutlinedIcon sx={{ fontSize: 22, color: "#6d28d9" }} />
                    Attachments
                  </Box>
                  {hasInvoiceAttachments ? (
                    <Box className="qdj-attachments-wrap">
                      <DisplayImage
                        files={
                          Array.isArray(invoiceAttachmentsRaw)
                            ? invoiceAttachmentsRaw
                            : [invoiceAttachmentsRaw]
                        }
                        IsDeleted={false}
                        attachmentFileNamesEllipsis
                      />
                    </Box>
                  ) : (
                    <Typography sx={{ fontSize: 14, color: d.noteEmpty }}>
                      No attachment found.
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
      {/* JOB-3411: unified PDF viewer dimensions (90vw / 90vh). */}
      <Dialog
        open={openSignPDF}
        onClose={handleCloseDialog}
        maxWidth="lg"
        fullWidth
        className="p-0"
        style={{ background: "transparent" }}
        PaperProps={{
          sx: {
            width: { xs: "95%", sm: "90%" },
            maxWidth: { xs: "100%", sm: "1200px" },
            margin: { xs: "10px", sm: "20px" },
            height: { xs: "95vh", sm: "90vh" },
            maxHeight: { xs: "95vh", sm: "90vh" },
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <DialogContent sx={{ p: 0, flex: 1, overflow: "hidden" }}>
          <iframe
            src={selectedFileUri}
            width="100%"
            height="100%"
            title="PDF Viewer"
            style={{
              border: "none",
              display: "block",
            }}
          ></iframe>
        </DialogContent>
        <DialogActions style={{ padding: "10px", flexWrap: "wrap" }}>
          <BlueButton onClick={handleCloseDialog} label="Close" />
        </DialogActions>
      </Dialog>
      <InvoiceMail
        modal={mail}
        setModal={setMail}
        customerData={invoicedata?.customer}
        Total={invoicedata?.Total}
        invoiceData={invoicedata}
        data={data}
        QuoteNumber={invoicedata?.QuoteNumber}
        Attachment={invoicedata?.Attachment}
        DueDate={invoicedata?.DueDate}
        tokenDecode={tokenDecode}
      />
    </>
  );
};

export default InvoiceDetail;
